import { render, staticRenderFns } from "./UploadSettings.vue?vue&type=template&id=3f09fbae"
import script from "./UploadSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadSettings.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UploadSettings.vue?vue&type=style&index=0&id=3f09fbae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports